// Get Cookie
export const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Parse cookie/localStorage JSON that may be raw or URI-encoded
 * (e.g. %7B%22name%22... from shared .enabill.com auth cookies).
 */
export const parseCookieJson = (raw) => {
  if (raw == null || raw === "") return null;
  let value = String(raw).trim();
  try {
    if (/%7B|%7b|%22|%5B|%5b/.test(value)) {
      value = decodeURIComponent(value);
    }
    return JSON.parse(value);
  } catch (e) {
    try {
      return JSON.parse(decodeURIComponent(String(raw).trim()));
    } catch (e2) {
      return null;
    }
  }
};

// Set Cookie
export const setCookie = (name, value, days) => {
  var domain, domainParts, date, expires, host;
  if (days) {
    date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }

  // Encode JSON so `{` / `"` do not break cookie parsing across subdomains.
  const safeValue =
    typeof value === "string" && (value.startsWith("{") || value.startsWith("["))
      ? encodeURIComponent(value)
      : value;

  host = window.location.host;
  if (host.split(".").length === 1) {
    // no "." in a domain - it's localhost or something similar
    document.cookie = name + "=" + safeValue + expires + "; path=/";
  } else {
    domainParts = host.split(".");
    domainParts.shift();
    domain = "." + domainParts.join(".");
    document.cookie =
      name + "=" + safeValue + expires + "; path=/; domain=" + domain;
    if (getCookie(name) === null || getCookie(name) !== safeValue) {
      domain = "." + host;
      document.cookie =
        name + "=" + safeValue + expires + "; path=/; domain=" + domain;
    }
  }
};

// Erase The Cookie
export const erase = (name) => {
  setCookie(name, "", -1);
};
